/**
 * Created by denismcgovern on 2/22/18.
 */
import { AfterViewInit, Component, ElementRef, Input, SimpleChanges, ViewChild, ChangeDetectorRef } from '@angular/core';
import Highcharts from 'highcharts';
import * as api from '../../../../api';
import { FacilitiesService, Facility } from '../../../../core/facilities/facilities.service';
import { ChartOptionsFactory } from '../../../chart-options-factory';
import { AbstractAggregateChartsComponent } from "../../abstract-aggregate-charts.component";
import { BLUE, GREEN, ORANGE } from "../../../colors";
import { CurrencyPipe } from "@angular/common";
import { takeUntil } from 'rxjs/operators';

/**
 * Total Pharmacy Cost Summary Widget - shows pair of charts.
 */
@Component({
    selector: 'my-billing-summary-chart',
    template: `
        <div>
            <div dropdown class="dropdown"  style="left:70%; top:-57px">
                <button dropdownToggle class="btn btn-dropdown dropdown-link"> 
                    {{selectedFacility.name}}
                    <span class="caret"></span>
                </button>
                <ul *dropdownMenu class="select-dropdown dropdown-menu coroporate-dropdown" role="menu">
                    <li role="menuitem" *ngFor="let fac of allFacilities">
                        <div class="dropdown-item" (click)="selectThisFacility(fac)">
                            {{fac.name}}
                        </div>
                    </li>
                </ul>
            </div>
            <div class="row">
                <div class="billing-summary col-4">
                    <div class="title">Last Month</div>
                    <div class="cost">{{billed}}</div>
                </div>
                <div class="billing-summary col-4">
                    <div class="title">Current Unbilled</div>
                    <div class="cost">{{unbilled}}</div>
                </div>
                <div class="billing-summary col-4">
                    <div class="title">Projected</div>
                    <div class="cost">{{projected}}</div>
                </div>
            </div>
            <div class="col-12">
                <div #billingSummaryChart style="height: 250px;"></div>
            </div>
        </div>
    `,
    styleUrls: ['../../../../home/dashboard/dashboard-corporate.component.scss']

})
export class CorporateDashBillingSummaryChart extends AbstractAggregateChartsComponent implements AfterViewInit {

    ////// Donut Chart of Total Cost
    @ViewChild('billingSummaryChart', {static: true}) billingSummaryChartDivRef: ElementRef;
    private billingSummaryChart: Highcharts.Chart;

    /** Construct */
    constructor(private financialApi: api.FinancialService,
                facilitiesSvc: FacilitiesService, private changeDetRef: ChangeDetectorRef) {
        super(facilitiesSvc);
    }

    selectedFacility: Facility = {
        id: ' ',
        name: ' ',
        isFacility: true,
        selected: false
    };
    allFacilities: Facility[] = [];

    currencyPipe: CurrencyPipe = new CurrencyPipe('en');

    selectThisFacility(fac: Facility){
        this.stop$.next(true);
        this.selectedFacility = fac;
        if(this.billingSummaryChart) {
            this.clearChart(this.billingSummaryChart);
        }
        this.buildAllCharts();
        this.fetchAndPopulate();
    }

    ngOnChanges(charges: SimpleChanges) {
    }

    unbilled = '$-';
    billed = '$-';
    projected = '$-';

    ngOnInit(){
        this.facilitiesSvc.selectedFacilities$.pipe(takeUntil(this.destroy$)).subscribe((facilities) => {
            if(facilities.length){
                let selectedFac = facilities.find(x => x.isFacility);
                if (selectedFac) {
                    this.selectThisFacility(facilities[0]);
                    this.allFacilities = facilities;
                }
            }
        })
    }

    ngAfterViewInit(){
        // cut out the top level
        if(!this.billingSummaryChart){
            this.buildAllCharts();
        }
        this.changeDetRef.detectChanges();
    }

    valueFormatter(value: number): string{
        let stringValue =  this.currencyPipe.transform(value, "USD", "symbol", ".0");
        return stringValue;

    }

    /**
     * Setup the charts.
     * @override
     */
    buildAllCharts(): void {
        let billingSummaryChartOptions = ChartOptionsFactory.buildBarType('', 'Cost', value => this.valueFormatter(value));
        billingSummaryChartOptions.legend = {}
        billingSummaryChartOptions.legend.enabled = false;
        billingSummaryChartOptions = ChartOptionsFactory.removeTitleTooltip(billingSummaryChartOptions, 'subtitle');
        this.billingSummaryChart = this.createChart(this.billingSummaryChartDivRef, billingSummaryChartOptions);
        this.billingSummaryChart.showLoading()
    }

    createChart(chartDivRef: ElementRef, options: Highcharts.Options){
        options.chart.renderTo = chartDivRef.nativeElement;
        let chart = new Highcharts.Chart(options);
        return chart;
    }

    /**
     * Fetch all data and update display
     * @override
     */
    fetchAndPopulate(): void {
        this.unbilled = '$-';
        this.billed = '$-';
        this.projected = '$-';

        if(this.selectedFacility && this.selectedFacility.id != ''){
            this.financialApi.financialGetBillingSummaryData(this.selectedFacility.id).pipe(takeUntil(this.stop$)).subscribe((data)=>{
                let proj = data.find(x => x.GroupName === 'Projected');
                if(proj) {
                    this.projected = this.valueFormatter(proj.ItemCount);
                }

                this.billingSummaryChart.options.colors = [BLUE, ORANGE, GREEN]
                this.populateBars(this.billingSummaryChart, this.transformAggregateData(data), "At least three full months of billing data is required to display this graph.");


                let last = data.find(x => x.GroupName === 'Last Month');
                if(last){
                    this.billed = this.valueFormatter(last.ItemCount);
                }

                let unbill = data.find(x => x.GroupName === 'Current Unbilled');
                if (unbill){
                    this.unbilled = this.valueFormatter(unbill.ItemCount);
                }


            });
        }
    }
}